<template>
  <div class="">
    <el-card class="card_1">
      <div class="card_image">
        <el-image
          style="width: 100%"
          :src="pavilion.imgUrl"/>
      </div>
      <div class="card_info">
        <p style="margin-top:10px;font-weight: bolder;font-size: 17px">{{ pavilion.pavilionName }}</p>
        <p style="margin-top:5px">{{ pavilion.pavilionPlace }}</p>
        <p style="margin-top:5px">开放时间: {{ findContinuousTimeSlots(pavilion.scheduling.timeSlot) }}</p>
        <p style="margin:10px 0;font-weight: bolder;font-size: 17px">排班时间</p>
      </div>
      <div class="card_info">
        <div v-if="pavilionAppoints.length>0">
          <el-row v-for="(appoint,i) in pavilionAppoints" :key="i"
                  style="margin-bottom:12px;">
            <el-col :span="16"
                    style="color:#303133;background-color:#D3DAF4;height:32px;padding:7px 10px;border-radius: 4px 0 0 4px ;">
              {{ appoint.planDate + ' ' + appoint.weekDay }}
            </el-col>
            <el-col :span="8">
              <el-button type="primary" :disabled="appoint.surplus <= 0 || appoint.opening === 0"
                         @click="selectAppointUI(appoint)"
                         style="padding: 9px 20px;border: none;border-radius: 0 4px 4px 0;width:100%">
                {{ canAppointInfo(appoint) }}
              </el-button>
            </el-col>
          </el-row>
        </div>
        <el-empty v-else description="暂无数据"/>
      </div>
    </el-card>
    <el-dialog :visible="selectAppoint" width="100%" :show-close="false" class="selectTime">
      <h3 class="text-center">
        {{ pavilion.pavilionName }}
        <small style="margin-left:24px;">
          {{ pavilionAppoint.planDate + ' ' + pavilionAppoint.weekDay }}
        </small>
      </h3>
      <div :style="{height: (windowInnerHeight / 2) + 'px',overflow: 'auto'}">
        <el-checkbox-group v-model="checked" @change="pavilionAppointmentCheck"
                           :max="pavilionAppointmentTimes[0].limit <= -1 ? 24 : pavilionAppointmentTimes[0].limit">
          <template v-for="(appoint,index) in pavilionAppointmentTimes">
            <el-checkbox style="margin: 3px" v-show="appoint.canBeUsed >= 0 && isTimeGreaterThanNow(appoint.startTime)"
                         :key="index" :label="index" size="small"
                         :disabled="appoint.canBeUsed < 0 || pauseSelect" border>
            <span :style="{'color': getColor(appoint.canBeUsed)}">
              {{ appoint.startTime + '-' + appoint.endTime }}
            </span>
            </el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <el-button style="margin: 10px" @click="selectAppoint = false" round>取 消</el-button>
      <el-button style="margin: 10px" type="primary" @click="confirmAppointTimeUI" round>确 定</el-button>
    </el-dialog>
    <el-dialog :visible="confirmAppoint" width="100%" :show-close="false" class="selectTime">
      <el-card class="box-card" style="margin: 15px;border: 1px solid #DCDFE6;">
        <ConfirmPavilionAppointInfo :pavilion="pavilion" :pavilionAppoint="pavilionAppoint"
                                    :pavilionAppointArr="pavilionAppointArr"/>
      </el-card>
      <el-button style="margin: 10px" @click="confirmAppoint = false" round>取 消</el-button>
      <el-button style="margin: 10px" type="primary" @click="confirmAppointTime(pavilionAppoint.planDate)" round>确 定
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import HttpRequest from "@/utils/request";
import ConfirmPavilionAppointInfo from "@/components/confirmPavilionAppointInfo.vue";
import {h} from "vue";
import {findContinuousTimeSlots, getColor} from "@/assets/js/pavilion";

export default {
  components: {ConfirmPavilionAppointInfo},
  data() {
    return {
      windowInnerHeight: 0,
      pavilion: {},
      pavilionAppoints: [],
      pavilionAppoint: {},
      pavilionAppointArr: [{}, {}],
      selectAppoint: false,
      confirmAppoint: false,
      pavilionAppointmentTimes: [
        {
          limit: -1,
          endEncrypKey: "2fa1ae3486e370a25059ab74fa5d1792",
          startTime: "01:00",
          endTime: "01:59",
          canBeUsed: 0,
          startEncrypKey: "4d9ec58cd09f98d5ec152849b6f56c68"
        }
      ],
      pauseSelect: false,
      checked: [],
      checked1: [],
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    this.windowInnerHeight = window.innerHeight
    let params = JSON.parse(this.$route.query.params)
    if (params) {
      this.pavilion = params
      this.getPavilionAppointByWhile(params.id, params.encrypKey)
    } else {
      this.$alert(
        '请求url缺乏必须的参数',
        {confirmButtonText: '返回', showClose: false})
        .then(() => {
          this.$router.go(-1);
        })
    }
  },
  mounted() {
    document.title = '面试亭预约'
  },
  methods: {
    findContinuousTimeSlots,
    getColor,
    h,
    isTimeGreaterThanNow(timeStr) {
      let dateTimeStr = this.pavilionAppoint.planDate + ' ' + timeStr
      // 当前时间
      const now = new Date();
      // 给定的时间
      const givenTime = new Date(dateTimeStr);
      // 比较给定时间是否大于当前时间
      return givenTime > now;
    },
    confirmAppointTime(planDate) {
      let pavilionAppointArr = this.pavilionAppointArr
      let url = "/constub/pavilionAppoint/addPavilionAppoint";
      let data = {
        token: this.student.token,
        smartPavilionId: this.pavilion.id,
        planDate: planDate,
        startTime: pavilionAppointArr[0].startTime,
        startEncrypKey: pavilionAppointArr[0].startEncrypKey,
        endTime: pavilionAppointArr[1].endTime,
        endEncrypKey: pavilionAppointArr[1].endEncrypKey
      };
      HttpRequest.requestFormPost(url, data).then(res => {
        this.selectAppoint = false
        this.confirmAppoint = false
        this.getPavilionAppointByWhile(this.pavilion.id, this.pavilion.encrypKey)
        if (res && res.result.success) {
          this.$alert(
            '预约成功 点击确定查看预约记录',
            {confirmButtonText: '确定', showClose: true})
            .then(() => {
              this.$router.push('/pavilionAppoint');
            })
        } else {
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });
    },
    canAppointInfo(appoint) {
      return appoint.opening === 0 ? '暂不可约' : (appoint.surplus > 0 ? `剩余 ${appoint.surplus} 时段` : '已约满');
    },
    selectAppointUI(appoint) {
      this.checked = []
      this.checked1 = []
      this.selectAppoint = true
      this.pavilionAppoint = appoint
      let url = "/constub/pavilionAppoint/getPavilionAppointTimeSlotByWhile";
      let data = {
        token: this.student.token,
        smartPavilionId: this.pavilion.id,
        planDate: appoint.planDate,
        encrypKey: appoint.encrypKey
      };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.pavilionAppointmentTimes = res.data;
        } else {
          this.selectAppoint = false
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });

    },
    confirmAppointTimeUI() {
      let checked = this.checked
      if (checked.length === 0) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        });
        return
      }
      let pavilionAppointmentTimes = this.pavilionAppointmentTimes
      const max = Math.max(...checked);
      const min = Math.min(...checked);
      this.pavilionAppointArr[0] = pavilionAppointmentTimes[min]
      this.pavilionAppointArr[1] = pavilionAppointmentTimes[max]
      this.selectAppoint = false
      this.confirmAppoint = true
    },
    getPavilionAppointByWhile(id, encrypKey) {
      let url = "/constub/pavilionAppoint/getPavilionAppointByWhile";
      let data = {
        token: this.student.token,
        smartPavilionId: id,
        encrypKey: encrypKey
      };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.pavilionAppoints = res.data;
        } else {
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });
    },
    pavilionAppointmentCheck(v) {
      this.pauseSelect = true
      let vLength = v.length
      let checked1 = this.checked1
      let c1L = checked1.length
      let pavilionAppointmentTimes = this.pavilionAppointmentTimes
      let index = this.arrayDifference(v, checked1)[0];
      let pf = index === 0 ? null : pavilionAppointmentTimes[index - 1]
      let pp = pavilionAppointmentTimes[index]
      let pa = index === pavilionAppointmentTimes.length - 1 ? null : pavilionAppointmentTimes[index + 1]
      //删除
      if (vLength < c1L) {
        if (pf !== null && pf.canBeUsed === 1 && pa !== null && pa.canBeUsed === 1) {
          this.checked = this.checked1
          this.$message('单次预约只能选择连续的时间段');
          this.pauseSelect = false
          return;
        }
        if (pp.canBeUsed === 1) {
          pp.canBeUsed = 0
        }
      }
      //新增
      if (vLength > c1L) {
        if (vLength < 2) {
          let pp = pavilionAppointmentTimes[index]
          if (pp.canBeUsed === 0) {
            pp.canBeUsed = 1
          }
          this.checked1 = this.checked
          this.pauseSelect = false
          return
        }
        let d = true;
        //判断是否连续
        if ((index === 0 && pp.canBeUsed === 0) && pa.canBeUsed === 1) {
          pp.canBeUsed = 1
          d = false
        }
        if ((index === pavilionAppointmentTimes.length - 1 && pp.canBeUsed === 0) && pf.canBeUsed === 1) {
          pp.canBeUsed = 1
          d = false
        }
        if ((0 < index && index < pavilionAppointmentTimes.length - 1) && (pf.canBeUsed === 1 || pa.canBeUsed === 1)) {
          pp.canBeUsed = 1
          d = false
        }
        if (d) {
          //删除
          this.checked.pop()
          this.$message('单次预约只能选择连续的时间段');
        }
      }
      this.checked1 = this.checked
      this.pauseSelect = false
    },
    arrayDifference(arr1, arr2) {
      let arrr = arr1.length >= arr2.length ? arr1 : arr2;
      let arrc = arr1.length >= arr2.length ? arr2 : arr1;
      return arrr.filter(element => !arrc.includes(element));
    }
  }
};
</script>

<style scoped>
>>> .el-card__body {
  padding: 0;
}

.card_1 {
  z-index: 888;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  width: calc(100% - 0px);
  height: calc(100% - 63px);
  overflow: auto;
}

.card_info {
  margin: 0 15px;
}

>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

.selectTime h3 {
  margin-bottom: 10px;
}

.selectTime >>> .el-dialog__body {
  padding: 0;
  text-align: center;
}

>>> .el-checkbox, >>> .is-bordered {
  margin-left: 0;
  margin-right: 0;
}
</style>
